module.exports = __webpack_public_path__ + "img/failed.fc69ceea.svg";